import React, { useEffect, useState } from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';
// import { useNavigate,  useParams } from 'react-router-dom';
import { Col, Row, Card, Button } from 'react-bootstrap';
import corner1 from 'assets/img/illustrations/corner-1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Background from 'components/common/Background';
import useAuth from 'hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { SettingsList } from './TriggersActions';

const DeviceAutomation = () => {
  const location = useLocation();
  const [historyState] = useState(location.state);
  const { t } = useTranslation();
  const { firestore } = useAuth();
  const [device, setDevice] = useState(null);
  const [deviceAutomation, setDeviceAutomation] = useState(null);
  const { gid, deviceId, id } = useParams();
  const [isTriggersLoading, setIsTriggersLoading] = useState(false);
  const [isActionsLoading, setIsActionsLoading] = useState(false);

  const [telemetryTypes, setTelemetryTypes] = useState(null);
  // const navigate = useNavigate();

  useEffect(() => {
    if (firestore) {
      firestore.getDevice(deviceId).then(device => {
        setDevice(device);
      });
      firestore.getDeviceAutomation(deviceId, id).then(_deviceAutomation => {
        setDeviceAutomation(_deviceAutomation);
      });
    }
  }, [firestore, gid, deviceId, id]);

  useEffect(() => {
    if (firestore) {
      Promise.all([firestore.getTelemetryTypes()]).then(([telemetryTypes]) => {
        console.log(telemetryTypes);
        setTelemetryTypes(telemetryTypes);
      });
    }
  }, [firestore]);

  return (
    <>
      {deviceAutomation && device && telemetryTypes && (
        <>
          <Row className="g-3 mb-3">
            <Col lg={12} className="gx-0">
              <Card className={`overflow-hidden`}>
                <Background image={corner1} className="p-card bg-card" />
                <Card.Body className="position-relative">
                  <h3 className="">{deviceAutomation.name}</h3>
                  <p className="fs--1 mb-0">{t('deviceAutomation')}</p>
                  {historyState && (
                    <Button
                      as={Link}
                      variant="link"
                      className="fs--1 text-primary mt-1 pb-0 ps-0"
                      to={`/group/${gid}/device/${deviceId}`}
                      state={{ group: historyState.group }}
                    >
                      <FontAwesomeIcon icon="chevron-left" className="fs--1" />{' '}
                      {t('backTo')} {historyState.group.name}
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col lg={12} className="gx-0">
              <Row className="g-3 mb-3">
                <Col lg={6} className="">
                  <SettingsList
                    title={t('triggers')}
                    subTitle={t('trigger')}
                    isLoading={isTriggersLoading}
                    hasTypeField={true}
                    defaultSettings={deviceAutomation.triggers}
                    defaultType={deviceAutomation.triggers_type}
                    device={device}
                    telemetryTypes={telemetryTypes}
                    supportedSettingTypes={['time']}
                    onSave={(triggers, triggersType) => {
                      console.log(triggers, triggersType);
                      setIsTriggersLoading(true);
                      firestore
                        .setTriggersOfDeviceAutomation(
                          deviceId,
                          id,
                          triggers,
                          triggersType
                        )
                        .then(() => {
                          firestore
                            .getDeviceAutomation(deviceId, id)
                            .then(_deviceAutomation => {
                              setDeviceAutomation(_deviceAutomation);
                              setIsTriggersLoading(false);
                            });
                        });
                    }}
                  />
                </Col>
                <Col lg={6} className="">
                  <SettingsList
                    title={t('actions')}
                    subTitle={t('action')}
                    isLoading={isActionsLoading}
                    hasTypeField={false}
                    defaultSettings={deviceAutomation.actions}
                    device={device}
                    telemetryTypes={telemetryTypes}
                    supportedSettingTypes={[
                      'port-turn-on',
                      'port-turn-off',
                      'port-turn-toggle-on'
                    ]}
                    onSave={actions => {
                      console.log(actions);
                      setIsActionsLoading(true);
                      firestore
                        .setActionsOfDeviceAutomation(deviceId, id, actions)
                        .then(() => {
                          firestore
                            .getDeviceAutomation(deviceId, id)
                            .then(_deviceAutomation => {
                              setDeviceAutomation(_deviceAutomation);
                              setIsActionsLoading(false);
                            });
                        });
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default DeviceAutomation;
